import { combineReducers } from 'redux'
import colors from './productColor'
import categories from './categories'

export default combineReducers({
    colors,
    categories
})


// WEBPACK FOOTER //
// ./src/reducers/index.ts